import { render, staticRenderFns } from "./FloatingPointsLoader.vue?vue&type=template&id=8fe4c3a8&scoped=true&"
import script from "./FloatingPointsLoader.vue?vue&type=script&lang=js&"
export * from "./FloatingPointsLoader.vue?vue&type=script&lang=js&"
import style0 from "./FloatingPointsLoader.vue?vue&type=style&index=0&id=8fe4c3a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe4c3a8",
  null
  
)

export default component.exports